import ApiClient from 'api-client/ApiClient'
const { resMgr } = ApiClient.getInstance()

export const hasHypervisorRole = (host) => {
  return (
    host?.roles?.includes('hypervisor') || host?.v1Roles?.includes('pf9-ostackhost-neutron-vmw')
  )
}

export const hasNetworkingRole = (host) => {
  // this will change
  return host.roles.includes('pf9-neutron-base')
}

export const hasImageLibraryRole = (host) => {
  return !!host?.roles?.includes('image-library')
}

export const hasDnsRole = (host) => {
  return host?.roles?.includes('dns') ?? false
}

export const hasCinderRole = (host) => {
  return !!host?.roles?.includes('persistent-storage')
}

export const hasRemoteSupportRole = (host) => {
  return !!host.v1Roles?.includes('pf9-support')
}

export const getHostConfiguredIp = (host) => {
  return ''
}

export const getHostRoleConfig = async (host, role) => {
  const roleConfig = await resMgr.getRole(host.id, role)
  return roleConfig
}

export const hostUnhealthy = (host) => {
  return (
    ['offline', 'failed', 'error'].includes(host?.role_status) || host?.info?.responding === false
  )
}

export const ControlPlaneServiceUnhealthyMessage =
  'One or more management plane services are degraded. Some actions might take longer or fail unexpectedly.'

export const getHeaderAlertMessage = ({ hypervisor, imageLibrary, blockStorage, network }) => {
  if (hypervisor && imageLibrary && blockStorage && network) {
    return 'Majority of hosts with Hypervisor, Image Library, Persistent Storage, and Networking roles are unhealthy. Taking any action involving VMs, images, volumes, or networks may be impacted.'
  }
  if (hypervisor && imageLibrary && blockStorage) {
    return 'Majority of hosts with Hypervisor, Image Library, and Persistent Storage roles are unhealthy. Taking any action involving VMs, images, or volumes may be impacted.'
  }
  if (hypervisor && imageLibrary && network) {
    return 'Majority of hosts with Hypervisor, Image Library, and Networking roles are unhealthy. Taking any action involving VMs, images, or networks may be impacted.'
  }
  if (hypervisor && blockStorage && network) {
    return 'Majority of hosts with Hypervisor, Persistent Storage, and Networking roles are unhealthy. Taking any action involving VMs, volumes, or networks may be impacted.'
  }
  if (imageLibrary && blockStorage && network) {
    return 'Majority of hosts with Image Library, Persistent Storage, and Networking roles are unhealthy. Taking any action involving images, volumes, or networks may be impacted.'
  }
  if (hypervisor && imageLibrary) {
    return 'Majority of hosts with Hypervisor and Image Library roles are unhealthy. Taking any action involving VMs or images may be impacted.'
  }
  if (hypervisor && blockStorage) {
    return 'Majority of hosts with Hypervisor and Persistent Storage roles are unhealthy. Taking any action involving VMs or volumes may be impacted.'
  }
  if (imageLibrary && blockStorage) {
    return 'Majority of hosts with Image Library and Persistent Storage roles are unhealthy. Taking any action involving images or volumes may be impacted.'
  }
  if (hypervisor && network) {
    return 'Majority of hosts with Hypervisor and Networking roles are unhealthy. Taking any action involving VMs or networks may be impacted.'
  }
  if (imageLibrary && network) {
    return 'Majority of hosts with Image Library and Networking roles are unhealthy. Taking any action involving images or networks may be impacted.'
  }
  if (blockStorage && network) {
    return 'Majority of hosts with Persistent Storage and Networking roles are unhealthy. Taking any action involving volumes or networks may be impacted.'
  }
  if (hypervisor) {
    return 'Majority of hosts with Hypervisor roles are unhealthy. Taking any action involving VMs may be impacted.'
  }
  if (imageLibrary) {
    return 'Majority of hosts with Image Library roles are unhealthy. Taking any action involving images may be impacted.'
  }
  if (blockStorage) {
    return 'Majority of hosts with Persistent Storage roles are unhealthy. Taking any action involving volumes may be impacted.'
  }
  if (network) {
    return 'Majority of hosts with Networking roles are unhealthy. Taking any action involving networks may be impacted.'
  }
  return ''
}

export const getWizardAlertMessage = ({
  hypervisor,
  imageLibrary,
  blockStorage,
  network,
  action,
}) => {
  if (hypervisor && imageLibrary && blockStorage) {
    return `Majority of hosts with Hypervisor, Image Library, and Persistent Storage roles are unhealthy. ${action} may be impacted.`
  }
  if (hypervisor && imageLibrary) {
    return `Majority of hosts with Hypervisor and Image Library roles are unhealthy. ${action} may be impacted.`
  }
  if (hypervisor && blockStorage) {
    return `Majority of hosts with Hypervisor and Persistent Storage roles are unhealthy. ${action} may be impacted.`
  }
  if (imageLibrary && blockStorage) {
    return `Majority of hosts with Image Library and Persistent Storage roles are unhealthy. ${action} may be impacted.`
  }
  if (hypervisor) {
    return `Majority of hosts with Hypervisor roles are unhealthy. ${action} may be impacted.`
  }
  if (imageLibrary) {
    return `Majority of hosts with Image Library roles are unhealthy. ${action} may be impacted.`
  }
  if (blockStorage) {
    return `Majority of hosts with Persistent Storage roles are unhealthy. ${action} may be impacted.`
  }
  // Todo: If we want to show this network warning on combined
  // pages, then we need to add conditions above (currently
  // there are none)
  if (network) {
    return `Majority of hosts with Networking roles are unhealthy. ${action} may be impacted.`
  }
  return ''
}

export const toMHz = (value) => value * 1024
export const toGiB = (value) => value / 1024

export const mergeHypervisorsWithHosts = (hypervisorsList, hosts) => {
  if (!hypervisorsList || !hosts) return []

  const hostsById = new Map(hosts.map((h) => [h.id, h]))

  return hypervisorsList.reduce((acc, hv) => {
    const host = hostsById.get(hv?.service?.host)
    if (host && hv && typeof hv === 'object' && typeof host === 'object') {
      return [...acc, { ...hv, ...host }]
    }
    return acc
  }, [])
}
